<template>
    <button
        type="submit"
        class="btn btn-primary"
        :disabled="sending"
    >

        <slot v-if="sending" name="sending">
            {{sendingText}} <i class="fa fa-circle-o-notch fa-spin ml-2"></i>
        </slot>
        <slot v-else name="button">
            {{text}}
        </slot>
    </button>
</template>

<script>
    export default {
        name: "BaseButtonSubmit",
        props: {
            text: {
                type: String,
                default: 'Wyślij'
            },
            sendingText: {
                type: String,
                default: 'Wysyłanie...'
            },
            sending: {
                type: Boolean,
                default: false
            }
        }
    }
</script>